export const BULK_MANAGER = {
    HEADER: "BULK_MANAGER_HEADER",
    EXPAND: "BULK_MANAGER_EXPAND",
    DISMISS: "BULK_MANAGER_DISMISS",
    TOAST_DRAWER: "BULK_MANAGER_TOAST_DRAWER",
    PROCESSES: "BULK_MANAGER_PROCESSES",
    INFO: "BULK_MANAGER_INFO",
    CANCEL: "CANCEL_LINK",
};
